import type { CoreEnv, CoreUser } from '@eventbrite/legacy-infra.context-types';
import { GlobalNav } from '@eventbrite/consumer-header.global-nav';
import { ConsumerHeader } from '@eventbrite/consumer-header.consumer-header';
import styles from './GlobalHeader.module.scss';
import type { RequestShape } from '@eventbrite/consumer-header.global-nav/types';

export interface GlobalHeaderProps {
    env: Partial<CoreEnv> & {
        launchNewSignInSignUpLinks?: boolean;
        isManageOverviewActive?: boolean;
    };
    user: Partial<CoreUser> | null; //TODO: confirm what do we use UserShape or CoreUser
    request: RequestShape;
    isHomePage?: boolean;
}

export const GlobalHeader: React.FunctionComponent<GlobalHeaderProps> = ({
    env,
    user,
    request,
    isHomePage,
}) => {
    let header;
    //FIXME: fix types
    const coreEnv = env as CoreEnv;

    if (user) {
        header = (
            <ConsumerHeader
                env={coreEnv}
                request={request}
                user={user}
                isHomePage={isHomePage}
                featureFlags={{}}
            />
        );
    } else {
        header = <GlobalNav user={{}} env={env} />;
    }

    return <div className={styles.root}>{header}</div>;
};
